import { ReactNode, FC } from "react";
import {
  Box,
  useColorModeValue,
  Drawer,
  DrawerContent,
  useDisclosure,
} from "@chakra-ui/react";
import Sidebar from "components/Sidebar";
import MobileNav from "components/MobileNav";
import { PrivateRoute } from "./AuthProvider";
import Profile from "./Profile";
import ChangePassword from "./ChangePassword";

interface LayoutProps {
  withSidebar?: boolean;
  isPrivate?: boolean;
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({
  children,
  withSidebar = true,
  isPrivate = false,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const colorMode = useColorModeValue("gray.100", "gray.900");

  const content = !withSidebar ? (
    <Box minH="100vh" bg={colorMode}>
      {children}
    </Box>
  ) : (
    <Box minH="100vh" bg={colorMode}>
      <Sidebar
        onClose={() => onClose}
        display={{ base: "none", md: "block" }}
      />
      <Drawer
        autoFocus={false}
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <Sidebar onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* mobilenav */}
      <MobileNav onOpen={onOpen} />
      <Box ml={{ base: 0, md: 60 }} p="4">
        {children}
      </Box>
      <Profile />
      <ChangePassword />
    </Box>
  );

  return isPrivate ? <PrivateRoute>{content}</PrivateRoute> : content;
};

export default Layout;
